import simbApi from ".";
import { SEED_BOARDS_COLUMN } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

/**
 * Board Settings "Revalidate" next to the app's "Boards" column. The backend queues the fill
 * as orchestration jobs and answers 202 with a requestId; the completion arrives over the
 * notification socket (useBoardsColumnSeedStream).
 */
export const seedBoardsColumn = async (access_token: string, boardId: number) => {
  try {
    const response = await simbApi.post(
      SEED_BOARDS_COLUMN,
      { boardid: boardId },
      { headers: { Authorization: `Bearer ${access_token}` } },
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};
